import React, { useState } from "react"
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadingIcon from '@mui/icons-material/Downloading';
import VideoCameraBackIcon from '@mui/icons-material/VideoCameraBack';


const VideoMaker = () => {
  const [activeTab, setActiveTab] = useState("create")
  const [activeButton, setActiveButton] = useState("alloy")
  const [selectedOption, setSelectedOption] = useState(null)

  const buttons = ["alloy", "echo", "fable", "nova", "onyx", "shimmer"]

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName)
  }

  return (
    <div className="px-4 py-6">
      <div className="p-[14px] shadow-md rounded-lg mb-[20px] bg-white">
        <h1 className="text-[16px] md:text-[18px] cursor-pointer font-medium text-gray-900 mb-2">
          Video Maker
        </h1>
        <div className="flex items-center text-sm text-gray-500">
          <a href="/" className="hover:text-gray-700">
            Home
          </a>
          <span className="mx-2">
            <ChevronRightIcon className="w-4 h-4" />
          </span>
          <span className="text-gray-700">Video Maker</span>
        </div>
      </div>
      <div className="flex items-center mb-[20px] justify-between flex-wrap gap-[14px]">
        <div className="flex items-center gap-[16px]">
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium rounded-2xl shadow-md bg-white text-[13px] md:text-[14px] text-[#27004a]">
            geminiAi: 99157
          </button>
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium rounded-2xl shadow-md bg-white text-[13px] md:text-[14px] text-[#008000]">
            OpenAi: 76904
          </button>
        </div>
        <div className="flex items-center gap-[16px]">
          <button
            className={`second-btn ${
              activeTab === "create"
                ? "bg-white text-[#27004a] shadow-md"
                : " text-gray-700"
            }`}
            onClick={() => setActiveTab("create")}
          >
            Create Video
          </button>
          <button
            className={`first-btn ${
              activeTab === "history"
                ? "bg-white text-[#27004a] shadow-md"
                : ""
            }`}
            onClick={() => setActiveTab("history")}
          >
            Video History
          </button>
        </div>
      </div>
      {activeTab === "create" && (
        <div className="p-[14px] shadow-cs bg-white rounded-lg">
          <div className="w-full max-w-2xl mx-auto p-6 space-y-8">
            <div className="text-center space-y-2">
              <h2 className="text-2xl font-semibold flex items-center justify-center gap-2">
                <MusicNoteIcon className="w-6 h-6" />
                Choose audio
              </h2>
            </div>

            <div className="grid  md:grid-cols-3 gap-4">
              <button
                onClick={() => setSelectedOption("upload")}
                className={`p-4 rounded-xl border-2 transition-all duration-200 flex flex-col items-center gap-2 hover:border-[#27004a] ${
                  selectedOption === "upload"
                    ? "border-[#27004a] bg-[#27004a]/5"
                    : "border-gray-200"
                }`}
              >
                <DriveFolderUploadIcon className="w-5 h-5 text-[#27004a]" />
                <span className="font-medium text-[#27004a]">Upload Audio</span>
              </button>

              <button
                onClick={() => setSelectedOption("ai")}
                className={`p-4 rounded-xl border-2 transition-all duration-200 flex flex-col items-center gap-2 hover:border-[#27004a] ${
                  selectedOption === "ai"
                    ? "border-[#27004a] bg-[#27004a]/5"
                    : "border-gray-200"
                }`}
              >
                <AutoFixHighIcon className="w-5 h-5" />
                <span className="font-medium">Let The AI Create It</span>
              </button>

              <button
                onClick={() => setSelectedOption("none")}
                className={`p-4 rounded-xl border-2 transition-all duration-200 flex flex-col items-center gap-2 hover:border-[#27004a] ${
                  selectedOption === "none"
                    ? "border-[#27004a] bg-[#27004a]/5"
                    : "border-gray-200"
                }`}
              >
                <CloseIcon className="w-5 h-5" />
                <span className="font-medium">None</span>
              </button>
            </div>

            <div className="space-y-3">
              <label className="text-lg font-medium">Choose voice</label>

              <div className="flex items-center gap-[16px] flex-wrap whitespace-nowrap">
                {buttons.map((button) => (
                  <button
                    key={button}
                    className={`rounded-2xl whitespace-nowrap text-[12px] md:text-[14px] pl-[18px] pr-[18px] font-medium pt-[5px] pb-[5px] shadow-md 
                      ${
                        activeButton === button
                          ? "bg-[#27004a] text-white"
                          : "text-black"
                      }`}
                    onClick={() => handleButtonClick(button)}
                  >
                    {button}
                  </button>
                ))}
              </div>
            </div>

            {selectedOption === "upload" && (
              <div className="border-2 border-dashed rounded-xl p-8 text-center">
                <div className="flex flex-col items-center gap-2">
                  <DriveFolderUploadIcon className="w-6 h-6 text-gray-400" />
                  <p className="text-sm text-gray-500">
                    Select or drag mp3 as audio
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {activeTab === "history" && (
      
         <div className="space-y-4">
          {[1,2].map((item) => (
            <div
              key={item}
              className="flex items-center justify-between p-4 bg-white rounded-lg shadow-cs"
            >
              <div className="flex items-center gap-2">
                <div>
             <VideoCameraBackIcon className="text-[#27004a]"/>
                </div>
                <div>
                  <p className="  text-[13px] md:font-medium md:text-[14px] ">16:4 months ago</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
              <DeleteOutlineIcon/>
                </button>
                <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
              <DownloadingIcon/>
                </button>
              </div>
            </div>
          ))}
        </div>
      
      )}
    </div>
  )
}

export default VideoMaker

